"use client";

import { useRouter } from "next/navigation";
import { useEffect, useState, type ReactNode } from "react";

/** Server decides initial visibility; this only retires an already-open banner. */
export function CampaignExpiry({ endsAt, children }: { endsAt: string; children: ReactNode }) {
	const [expiredDeadline, setExpiredDeadline] = useState<string | null>(null);
	const expired = expiredDeadline === endsAt;
	const router = useRouter();
	useEffect(() => {
		if (expired) router.refresh();
	}, [expired, router]);
	useEffect(() => {
		const deadline = Date.parse(endsAt);
		let timeout: number;
		const check = () => {
			window.clearTimeout(timeout);
			if (Date.now() >= deadline) setExpiredDeadline(endsAt);
			else timeout = window.setTimeout(check, Math.min(deadline - Date.now(), 2_147_483_647));
		};
		check();
		window.addEventListener("focus", check);
		document.addEventListener("visibilitychange", check);
		return () => {
			window.clearTimeout(timeout);
			window.removeEventListener("focus", check);
			document.removeEventListener("visibilitychange", check);
		};
	}, [endsAt]);
	return expired ? null : children;
}
